import { z } from "zod";
export const CloudAgentSummarySchema = z.object({
  id: z.string(),
  title: z.string(),
  status: z.string(),
  url: z.string(),
  prUrl: z.string().nullable(),
});
export type CloudAgentSummary = z.infer<typeof CloudAgentSummarySchema>;
